import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-button-row',
	templateUrl: 'button-row.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class ButtonRowComponent {}
